var map = {
	"./BlockElement": 14802,
	"./BlockElement/": 14802,
	"./BlockElement/index": 14802,
	"./BlockElement/index.tsx": 14802,
	"./BlockElement/styles": 24042,
	"./BlockElement/styles.ts": 24042,
	"./CentredLoader": 94711,
	"./CentredLoader/": 94711,
	"./CentredLoader/index": 94711,
	"./CentredLoader/index.tsx": 94711,
	"./ConfirmationPopups": 35293,
	"./ConfirmationPopups/": 35293,
	"./ConfirmationPopups/index": 35293,
	"./ConfirmationPopups/index.tsx": 35293,
	"./FileDownloadButton": 97705,
	"./FileDownloadButton/": 97705,
	"./FileDownloadButton/index": 97705,
	"./FileDownloadButton/index.tsx": 97705,
	"./Template": 37069,
	"./Template/": 37069,
	"./Template/index": 37069,
	"./Template/index.tsx": 37069,
	"./Toggle": 7639,
	"./Toggle/": 7639,
	"./Toggle/index": 7639,
	"./Toggle/index.tsx": 7639,
	"./Toggle/styles": 82275,
	"./Toggle/styles.ts": 82275,
	"./iconBlueRound": 31865,
	"./iconBlueRound.tsx": 31865,
	"./linkBack": 86875,
	"./linkBack.tsx": 86875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86900;